import { render, staticRenderFns } from "./DispatchOverview.vue?vue&type=template&id=3c83642a&scoped=true"
import script from "./DispatchOverview.vue?vue&type=script&lang=js"
export * from "./DispatchOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c83642a",
  null
  
)

export default component.exports